import React from "react"
import { Link } from "gatsby"
import "./solutions.scss"

const Solutions = ({ solutionsMenuItems }) => {
  return (
    <>
      <ul className="nav__dropdown">
        {solutionsMenuItems.map((MenuNavItem, idx) => {
          return (
            <li className="link nav__dropdown-item" key={idx}>
              <Link to={MenuNavItem.linksTo}>
                <img
                  src={MenuNavItem.icon}
                  className="nav__dropdown-icon"
                  alt=""
                />
                {MenuNavItem.navItem}
              </Link>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default Solutions
